import { isApiProduct } from '@/services/helpers/ProductHelper'
import { elb } from '@elbwalker/walker.js'

const PUSH_RETRY_MS = 500
const PUSH_MAX_ATTEMPTS = 30

// walker.js silently drops events pushed before the first `walker run`, which
// waits for the customer profile (up to ~5s for guests) — retry until running.
export const pushWalkerEvent = (event, data, attempt = 0) => {
  if (globalThis.window?.walkerjs?.allowed) {
    elb(event, data)
  } else if (attempt < PUSH_MAX_ATTEMPTS) {
    setTimeout(() => pushWalkerEvent(event, data, attempt + 1), PUSH_RETRY_MS)
  }
}

// ';' and ':' are walker.js attribute separators and must not appear in values
export const sanitizeSearchTermForTracking = (term) =>
  String(term ?? '')
    .toLowerCase()
    .replace(/[;:]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100)

export const WALKER_COMMANDS = {
  init: 'walker init',
  consent: 'walker consent',
  run: 'walker run',
  destination: 'walker destination'
}

class ElbwalkerHelper {
  constructor() {
    if (ElbwalkerHelper.Singleton) return
    ElbwalkerHelper.Singleton = this
  }

  getProductData(product) {
    let data

    if (isApiProduct(product)) {
      data = {
        product_id: product?.product_id,
        campaign_id: product?.campaign_id,
        name: `'${product?.name}'`,
        type: product?.type,
        price: product?.original_price,
        special_price: product?.final_price,
        sku: product?.sku,
        wine_type: product?.details?.wine_type,
        country: product?.details?.country,
        vendor_name:
          product?.stocks?.length > 0 ? product.stocks[0].name : undefined
      }
    } else {
      data = {
        product_id: product?.product_id,
        campaign_id: product?.campaign_id,
        name: `'${product?.name}'`,
        type: product?.type,
        price: product?.price?.original,
        special_price: product?.price?.final
      }
    }

    return Object.entries(data)
      .map(([key, value]) => `${key}:${value}`)
      .join(';')
  }
}

export default new ElbwalkerHelper()
